/* ==========================================================================
   THE SIBLING TIMES BUILDER — logic
   File: assets/cb-sibling-news.js   (REPLACE WHOLE FILE)
   Pages: black lines/boxes/text; empty photo slots filled light pink.
   ========================================================================== */
(function () {
  var ROOT = document.querySelector('.cb-snews');
  if (!ROOT) return;
  var MOUNT = ROOT.querySelector('[data-mount]');

  var CFG = {
    cloud: ROOT.dataset.cloud,
    preset: ROOT.dataset.preset,
    cartRedirect: ROOT.dataset.cartRedirect || '/cart',
    variants: JSON.parse(ROOT.dataset.variants || '[]'),
    variantId: ROOT.dataset.defaultVariant || ''
  };

  var W = 595.28, H = 841.89, CX = W / 2;
  var INK = '#231f20';      // all lines / boxes / text
  var FILL = '#f6cdd9';     // light-pink filler for empty photo slots
  var F_MAST = "'CB Chomsky','Pirata One',serif";
  var F_DISP = "'CB Mirage','Playfair Display',serif";
  var F_SCRIPT = "'CB Regista','Dancing Script',cursive";
  var ORDER = ['front', 'back', 'in1', 'in2', 'review'];

  var I = {
    heart: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 21s-7.5-4.6-10-9.2C.4 8.6 2 5 5.3 5c2 0 3.3 1.1 4.2 2.3l.4.5.4-.5C11.1 6.1 12.4 5 14.4 5 17.7 5 19.3 8.6 18 11.8 15.5 16.4 12 21 12 21z"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 13c4-6 9-6 13-5"/><path d="M13 5l4 3-3 4"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l1.6 5.6L19 9l-5.4 1.4L12 16l-1.6-5.6L5 9l5.4-1.4L12 2z"/></svg>',
    camera: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><rect x="3" y="7" width="18" height="13" rx="3"/><circle cx="12" cy="13.5" r="3.4"/><path d="M8 7l1.5-2.5h5L16 7"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h2l2.2 12.4a2 2 0 0 0 2 1.6h8.8a2 2 0 0 0 2-1.6L22 7H6"/></svg>',
    chevL: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
    chevR: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>',
    rosette: '<svg viewBox="0 0 40 40"><g fill="none" stroke="#9c3f5d" stroke-width="1.4"><circle cx="20" cy="17" r="9"/><circle cx="20" cy="17" r="5"/></g><path fill="#e89ab0" d="M15 24l-3 13 8-4 8 4-3-13z"/></svg>'
  };

  var SUGGEST = ['MANALI', 'RUPALI', 'LOVE', 'CHOCOS', 'NATRAJ', 'YELLOW', 'MEMORIES', 'HOME', 'CARE'];

  var S = {
    tab: 'front',
    front: { word: 'Sibling', date: 'Tuesday, April 20, 2024', place: 'Delhi', headline: 'Happy Rakshabandhan!', photo: null },
    back: { photos: [null, null, null, null] },
    in1: { sibling: 'Brother',
           letter: 'Dear bhai,\n\nFrom fighting over the remote to becoming my biggest cheerleader — thank you for every memory. You are my first friend and my forever person.',
           hero: null,
           polas: [{ p: null, c: '' }, { p: null, c: '' }, { p: null, c: '' }, { p: null, c: '' }] },
    in2: { moments: 'Road trips with too many snacks. Diwali card games we both cheated at. Late-night talks about nothing. The time we got lost and laughed the whole way home.',
           polas: [null, null, null, null],
           words: SUGGEST.slice() }
  };

  /* ---- measuring ----------------------------------------------------- */
  var _cx = document.createElement('canvas').getContext('2d');
  function fitWidth(txt, font, weight, maxW, maxFs, minFs) {
    var fs = maxFs;
    while (fs > minFs) { _cx.font = weight + ' ' + fs + 'px ' + font; if (_cx.measureText(txt).width <= maxW) break; fs -= 0.5; }
    return fs;
  }
  function wrapAt(txt, font, weight, fs, maxW) {
    _cx.font = weight + ' ' + fs + 'px ' + font; var out = [];
    (txt || '').split('\n').forEach(function (para) {
      if (para.trim() === '') { out.push(''); return; }
      var line = '';
      para.split(/\s+/).forEach(function (w) { var t = line ? line + ' ' + w : w; if (_cx.measureText(t).width > maxW && line) { out.push(line); line = w; } else line = t; });
      if (line) out.push(line);
    });
    return out;
  }
  function fitBlock(txt, font, weight, maxW, maxH, maxFs, minFs, lh) {
    for (var fs = maxFs; fs >= minFs; fs -= 0.5) { var lines = wrapAt(txt, font, weight, fs, maxW); if (lines.length * fs * lh <= maxH) return { fs: fs, lines: lines }; }
    return { fs: minFs, lines: wrapAt(txt, font, weight, minFs, maxW) };
  }

  /* ---- word search --------------------------------------------------- */
  var GN = 10;
  function rnd(n) { return Math.floor(Math.random() * n); }
  function buildGrid(words) {
    var g = []; for (var r = 0; r < GN; r++) g.push(new Array(GN).fill(''));
    var dirs = [[0,1],[1,0],[1,1],[1,-1],[0,-1],[-1,0],[-1,-1],[-1,1]];
    var clean = words.map(function (w) { return (w || '').toUpperCase().replace(/[^A-Z]/g, ''); }).filter(function (w) { return w.length && w.length <= GN; });
    clean.forEach(function (w) {
      for (var t = 0; t < 250; t++) {
        var d = dirs[rnd(dirs.length)], r0 = rnd(GN), c0 = rnd(GN);
        var rE = r0 + d[0]*(w.length-1), cE = c0 + d[1]*(w.length-1);
        if (rE<0||rE>=GN||cE<0||cE>=GN) continue;
        var ok = true, i;
        for (i=0;i<w.length;i++){ var ch=g[r0+d[0]*i][c0+d[1]*i]; if(ch&&ch!==w[i]){ok=false;break;} }
        if(!ok) continue;
        for (i=0;i<w.length;i++) g[r0+d[0]*i][c0+d[1]*i]=w[i];
        return;
      }
    });
    for (var a=0;a<GN;a++) for (var b=0;b<GN;b++) if(!g[a][b]) g[a][b]=String.fromCharCode(65+rnd(26));
    return { grid: g, clean: clean };
  }
  var GRID = buildGrid(S.in2.words);

  /* ---- svg helpers --------------------------------------------------- */
  var _cid = 0;
  function photo(x, y, w, h, href, tr, sw) {
    sw = sw || 6; var id = 'cbc' + (_cid++); var t = tr ? ' transform="' + tr + '"' : '';
    var img = href
      ? '<clipPath id="' + id + '"><rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '"/></clipPath>' +
        '<image href="' + href + '" x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid slice" clip-path="url(#' + id + ')"/>'
      : '';
    return '<g' + t + '>' +
      '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="' + (href ? '#fff' : FILL) + '" stroke="' + INK + '" stroke-width="' + sw + '" stroke-miterlimit="10"/>' +
      img +
      '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="none" stroke="' + INK + '" stroke-width="' + sw + '" stroke-miterlimit="10"/></g>';
  }
  function rules(top, bot) {
    top = top || 19.67; bot = bot || 822.22;
    function r(y, w) { return '<line x1="19.21" y1="' + y + '" x2="576.06" y2="' + y + '" stroke="' + INK + '"' + (w ? ' stroke-width="6"' : '') + '/>'; }
    return r(top, 1) + r(top + 9.8) + r(bot, 1) + r(bot - 9.8);
  }
  function svg(inner) { return '<svg viewBox="0 0 ' + W + ' ' + H + '" xmlns="http://www.w3.org/2000/svg"><rect width="' + W + '" height="' + H + '" fill="#fff"/>' + inner + '</svg>'; }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function tspans(lines, x, fs) { return lines.map(function (ln, i) { return '<tspan x="' + x + '" dy="' + (i === 0 ? 0 : fs * 1.32) + '">' + esc(ln) + '</tspan>'; }).join(''); }

  /* ---- page renderers (headlines centered) --------------------------- */
  function frontSVG(d) {
    var hlFs = fitWidth(d.headline, F_DISP, '500', 511, 46, 22);
    return svg(rules() +
      '<line x1="17.94" y1="152.35" x2="574.79" y2="152.35" stroke="' + INK + '"/>' +
      '<line x1="17.94" y1="185.54" x2="574.79" y2="185.54" stroke="' + INK + '"/>' +
      '<text x="' + CX + '" y="116.76" text-anchor="middle" font-family="' + F_MAST + '" font-size="64" fill="' + INK + '">The ' + esc(d.word || '____') + ' Times</text>' +
      '<text x="' + CX + '" y="176.51" text-anchor="middle" font-family="' + F_DISP + '" font-weight="500" font-size="18" letter-spacing="1" fill="' + INK + '">' + esc((d.date + ' | ' + d.place).toUpperCase()) + '</text>' +
      '<text x="' + CX + '" y="251.96" text-anchor="middle" font-family="' + F_DISP + '" font-weight="500" font-size="' + hlFs + '" fill="' + INK + '">' + esc(d.headline) + '</text>' +
      photo(42.04, 293.29, 511.19, 480, d.photo));
  }
  function backSVG(d) {
    var s = [[23.24,204.95],[320.29,204.95],[23.24,500.2],[320.29,500.2]];
    return svg(rules(24.66, 827.21) +
      '<text x="' + CX + '" y="78.4" text-anchor="middle" font-family="' + F_DISP + '" font-weight="500" font-size="35.7" fill="' + INK + '">TOGETHER WE ARE</text>' +
      '<text x="' + CX + '" y="131.37" text-anchor="middle" font-family="' + F_DISP + '" font-weight="700" font-size="52" fill="' + INK + '">ICONIC</text>' +
      s.map(function (p, i) { return photo(p[0], p[1], 251.74, 251.74, d.photos[i]); }).join('') +
      '<text x="' + CX + '" y="795.88" text-anchor="middle" font-family="' + F_DISP + '" font-size="14" fill="' + INK + '">printed @ craftsbazaar</text>');
  }
  function in1SVG(d) {
    /* letter now uses the SAME font as favourite-moments (F_DISP) */
    var letter = fitBlock(d.letter, F_DISP, '400', 250, 290, 19, 12, 1.4);
    var polas = [
      { x:46.07,  y:523.78, t:'translate(41.91 -5.83) rotate(4.12)' },
      { x:149.94, y:655.74, t:'translate(-130.83 51.75) rotate(-10.9)' },
      { x:285.79, y:531.46, t:'translate(-73.27 49.26) rotate(-7.45)' },
      { x:428.62, y:655.74, t:'translate(79.6 -48.11) rotate(6.19)' }
    ];
    var pol = polas.map(function (p, i) {
      var cap = d.polas[i].c ? '<text transform="' + p.t + '" x="' + (p.x + 55.9) + '" y="' + (p.y + 127) + '" text-anchor="middle" font-family="' + F_DISP + '" font-size="12" fill="' + INK + '">' + esc(d.polas[i].c) + '</text>' : '';
      return photo(p.x, p.y, 111.81, 111.81, d.polas[i].p, p.t) + cap;
    }).join('');
    return svg(rules() +
      '<text x="' + CX + '" y="84.14" text-anchor="middle" font-family="' + F_DISP + '" font-weight="500" font-size="26" fill="' + INK + '">' +
        '<tspan x="' + CX + '" dy="0">THANKS FOR BEING THE MOST</tspan>' +
        '<tspan x="' + CX + '" dy="30.7">AMAZING ' + esc(d.sibling.toUpperCase()) + '</tspan></text>' +
      photo(324.32, 161.93, 251.74, 251.74, d.hero) +
      '<text x="40" y="200" font-family="' + F_DISP + '" font-size="' + letter.fs + '" fill="' + INK + '">' + tspans(letter.lines, 40, letter.fs) + '</text>' +
      '<text x="' + CX + '" y="483.18" text-anchor="middle" font-family="' + F_DISP + '" font-weight="500" font-size="26" fill="' + INK + '">US THROUGH THE YEARS</text>' +
      pol);
  }
  function in2SVG(d, grid) {
    var mo = fitBlock(d.moments, F_DISP, '400', 470, 150, 26, 13, 1.4);
    var startY = 200 + (150 - mo.lines.length * mo.fs * 1.4) / 2;
    var moTxt = '<text text-anchor="middle" font-family="' + F_DISP + '" font-size="' + mo.fs + '" fill="' + INK + '">' +
      mo.lines.map(function (ln, i) { return '<tspan x="' + CX + '" y="' + (startY + i * mo.fs * 1.4) + '">' + esc(ln) + '</tspan>'; }).join('') + '</text>';
    var polas = [
      { x:44.09,  t:'translate(37.6 -6.71) rotate(5.07)' },
      { x:180.22, t:'translate(-14.19 8.09) rotate(-1.95)' },
      { x:313.89, t:'translate(21.72 -17.86) rotate(2.89)' },
      { x:450.68, t:'translate(-32.67 42.29) rotate(-4.68)' }
    ];
    var pol = polas.map(function (p, i) { return photo(p.x, 352.29, 100.95, 137.3, d.polas[i], p.t); }).join('');
    var ox = 41.65, oy = 572.14, cell = 21.85, cells = '';
    for (var r = 0; r < GN; r++) for (var c = 0; c < GN; c++) {
      cells += '<rect x="' + (ox+c*cell) + '" y="' + (oy+r*cell) + '" width="' + cell + '" height="' + cell + '" fill="none" stroke="' + INK + '" stroke-miterlimit="10"/>' +
        '<text x="' + (ox+c*cell+cell/2) + '" y="' + (oy+r*cell+cell/2+5) + '" text-anchor="middle" font-family="' + F_DISP + '" font-size="13" fill="' + INK + '">' + grid.grid[r][c] + '</text>';
    }
    var cols = [305.26, 381.42, 459.38], rows = [609.15, 637.35, 663.9], wl = '';
    grid.clean.slice(0, 9).forEach(function (w, i) { wl += '<text x="' + cols[Math.floor(i/3)] + '" y="' + rows[i%3] + '" font-family="' + F_DISP + '" font-size="14" fill="' + INK + '">' + w + '</text>'; });
    return svg(rules() +
      '<text x="' + CX + '" y="84.43" text-anchor="middle" font-family="' + F_DISP + '" font-weight="500" font-size="35.7" fill="' + INK + '">SOME OF OUR FAVOURITE</text>' +
      '<text x="' + CX + '" y="150" text-anchor="middle" font-family="' + F_SCRIPT + '" font-size="50" fill="' + INK + '" transform="rotate(-1.95 ' + CX + ' 150)">Memories</text>' +
      moTxt + pol +
      '<text x="' + CX + '" y="547.95" text-anchor="middle" font-family="' + F_DISP + '" font-weight="500" font-size="27.32" fill="' + INK + '">OUR OWN WORD SEARCH</text>' +
      cells +
      '<rect x="292.15" y="572.14" width="264.91" height="118.7" rx="13.52" fill="none" stroke="' + INK + '"/>' + wl);
  }
  function currentSVG() {
    if (S.tab === 'back') return backSVG(S.back);
    if (S.tab === 'in1') return in1SVG(S.in1);
    if (S.tab === 'in2') return in2SVG(S.in2, GRID);
    return frontSVG(S.front);
  }

  /* ---- Cloudinary ---------------------------------------------------- */
 function upload(file, btn, cb) {
    btn.classList.add('is-busy'); btn.innerHTML = 'Uploading…';
    var fd = new FormData(); fd.append('file', file); fd.append('upload_preset', CFG.preset);
    fetch('https://api.cloudinary.com/v1_1/' + CFG.cloud + '/image/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        btn.classList.remove('is-busy');
        if (j && j.secure_url) { cb(j.secure_url); }
        else { setUp(btn, false); console.error('Cloudinary error:', j);
          alert('Upload failed: ' + ((j && j.error && j.error.message) || 'check the unsigned preset name/cloud name')); }
      })
      .catch(function (err) { btn.classList.remove('is-busy'); setUp(btn, false);
        console.error(err); alert('Upload failed — network error.'); });
  }
  function pickPhoto(btn, cb) { var inp = document.createElement('input'); inp.type = 'file'; inp.accept = 'image/*'; inp.onchange = function (e) { var f = e.target.files[0]; if (f) upload(f, btn, cb); }; inp.click(); }
  function setUp(btn, set) { btn.classList.toggle('is-set', !!set); btn.innerHTML = (set ? I.spark + 'Photo added — replace' : I.camera + 'Upload photo'); }

  /* ---- dom helpers --------------------------------------------------- */
  function field(label, inner) { return '<label class="cb-snews__field"><span class="cb-snews__label">' + label + '</span>' + inner + '</label>'; }
  function hint(txt) { return '<span class="cb-snews__hint">' + I.arrow + esc(txt) + '</span>'; }
  function nav() {
    var idx = ORDER.indexOf(S.tab);
    var prev = idx > 0 ? ORDER[idx - 1] : null, next = idx < ORDER.length - 1 ? ORDER[idx + 1] : null;
    var h = '<div class="cb-snews__nav">';
    h += prev ? '<button class="cb-snews__navbtn" data-go="' + prev + '">' + I.chevL + 'Previous</button>' : '<span></span>';
    h += next ? '<button class="cb-snews__navbtn is-next" data-go="' + next + '">' + (next === 'review' ? 'Review' : 'Next') + I.chevR + '</button>' : '';
    return h + '</div>';
  }

  /* ---- render -------------------------------------------------------- */
  function render() {
    var tabs = [['front','Front'],['back','Back'],['in1','Inner 1'],['in2','Inner 2'],['review','Review']];
    MOUNT.innerHTML =
      '<div class="cb-snews__head">' + I.rosette.replace('<svg', '<svg class="cb-snews__rosette"') +
        '<div class="cb-snews__kicker">personalise your</div><h2 class="cb-snews__title">The Sibling Times</h2></div>' +
      '<svg class="cb-snews__scallop" viewBox="0 0 100 6" preserveAspectRatio="none"><path d="M0 6 Q5 0 10 6 T20 6 T30 6 T40 6 T50 6 T60 6 T70 6 T80 6 T90 6 T100 6 V6 H0Z" fill="currentColor"/></svg>' +
      '<div class="cb-snews__tabs" role="tablist">' +
        tabs.map(function (t) { return '<button class="cb-snews__tab" role="tab" data-tab="' + t[0] + '" aria-selected="' + (S.tab === t[0]) + '">' + (t[0] === 'review' ? I.cart : I.heart) + esc(t[1]) + '</button>'; }).join('') +
      '</div>' +
      '<div class="cb-snews__work">' +
        '<div class="cb-snews__preview' + (S.tab === 'review' ? ' is-review' : '') + '">' + previewInner() + '</div>' +
        '<div class="cb-snews__panel" data-panel></div></div>';
    MOUNT.querySelectorAll('.cb-snews__tab').forEach(function (b) { b.onclick = function () { S.tab = b.dataset.tab; render(); }; });
    panel(MOUNT.querySelector('[data-panel]'));
  }
  function previewInner() { return (S.tab === 'review') ? thumbs() : '<div class="cb-snews__paper">' + currentSVG() + '</div>'; }
  function thumbs() {
    var t = [['Front', frontSVG(S.front)], ['Back', backSVG(S.back)], ['Inner 1', in1SVG(S.in1)], ['Inner 2', in2SVG(S.in2, GRID)]];
    return '<div class="cb-snews__thumbs">' + t.map(function (x) { return '<div class="cb-snews__thumb"><div class="cb-snews__paper">' + x[1] + '</div><span>' + x[0] + '</span></div>'; }).join('') + '</div>';
  }
  function refreshPreview() { var pv = MOUNT.querySelector('.cb-snews__preview'); if (pv) pv.innerHTML = previewInner(); }

  /* ---- panels -------------------------------------------------------- */
  function panel(host) {
    var h = '';
    if (S.tab === 'front') {
      h = '<h3 class="cb-snews__h">' + I.spark + 'Front page</h3>' +
        field('Middle word in the title', '<input data-k="word" value="' + esc(S.front.word) + '" placeholder="Sibling">') +
        '<div class="cb-snews__row">' + field('Date', '<input data-k="date" value="' + esc(S.front.date) + '">') + field('Place', '<input data-k="place" value="' + esc(S.front.place) + '">') + '</div>' +
        field('Main headline (always centered)', '<input data-k="headline" value="' + esc(S.front.headline) + '">') +
        field('Main photo', '<button class="cb-snews__up" data-up="front.photo">' + I.camera + 'Upload photo</button>') + nav();
    } else if (S.tab === 'back') {
      h = '<h3 class="cb-snews__h">' + I.spark + 'Back page</h3>' + hint('“Together we are ICONIC” — upload 4 photos.') +
        S.back.photos.map(function (p, i) { return field('Photo ' + (i+1), '<button class="cb-snews__up" data-up="back.photos.' + i + '">' + I.camera + 'Upload photo</button>'); }).join('') + nav();
    } else if (S.tab === 'in1') {
      h = '<h3 class="cb-snews__h">' + I.heart + 'Inner page 1</h3>' +
        field('This newspaper is for my', '<div class="cb-snews__seg" data-seg="in1.sibling"><button data-v="Brother" aria-pressed="' + (S.in1.sibling === 'Brother') + '">Brother</button><button data-v="Sister" aria-pressed="' + (S.in1.sibling === 'Sister') + '">Sister</button></div>') +
        field('Words of love (shown as a letter)', '<textarea data-k="letter" rows="6">' + esc(S.in1.letter) + '</textarea>') +
        field('Hero photo (top right)', '<button class="cb-snews__up" data-up="in1.hero">' + I.camera + 'Upload photo</button>') +
        hint('“Us through the years” — 4 photos, captions optional.') +
        S.in1.polas.map(function (p, i) { return field('Photo ' + (i+1), '<button class="cb-snews__up" data-up="in1.polas.' + i + '.p">' + I.camera + 'Upload photo</button><input data-k="in1cap' + i + '" value="' + esc(p.c) + '" placeholder="caption (optional)">'); }).join('') + nav();
    } else if (S.tab === 'in2') {
      h = '<h3 class="cb-snews__h">' + I.heart + 'Inner page 2</h3>' +
        field('About our favourite moments (centered, auto-sized)', '<textarea data-k="moments" rows="4">' + esc(S.in2.moments) + '</textarea>') +
        hint('4 photos for the memories strip.') +
        S.in2.polas.map(function (p, i) { return field('Photo ' + (i+1), '<button class="cb-snews__up" data-up="in2.polas.' + i + '">' + I.camera + 'Upload photo</button>'); }).join('') +
        field('9 words for the word search', hint('Tap a suggestion to clear it, then type your own.') + '<div class="cb-snews__words">' +
          S.in2.words.map(function (w, i) { var def = (w === SUGGEST[i]); return '<input data-word="' + i + '" data-default="' + esc(SUGGEST[i]) + '" value="' + esc(w) + '"' + (def ? ' class="cb-snews__sugg"' : '') + ' placeholder="word ' + (i+1) + '">'; }).join('') + '</div>') + nav();
    } else {
      h = '<h3 class="cb-snews__h">' + I.cart + 'Review &amp; order</h3>' + hint('Check all four pages above. When it looks right, add to cart.');
      if (CFG.variants.length > 1) {
        h += field('Size', '<div class="cb-snews__sizes" data-sizes>' + CFG.variants.map(function (v) { return '<button class="cb-snews__size" data-vid="' + v.id + '" aria-pressed="' + (String(v.id) === String(CFG.variantId)) + '">' + esc(v.title) + ' · ' + v.price + '</button>'; }).join('') + '</div>');
      }
      h += '<div class="cb-snews__nav"><button class="cb-snews__navbtn" data-go="in2">' + I.chevL + 'Previous</button></div>' +
        '<button class="cb-snews__cta" data-addcart' + (CFG.variantId ? '' : ' disabled') + '>' + I.cart + 'Add to cart</button>';
    }
    host.innerHTML = h;
    wire(host);
  }

  /* ---- wiring -------------------------------------------------------- */
  function setPath(path, val) { var p = path.split('.'), o = S; for (var i = 0; i < p.length - 1; i++) o = o[p[i]]; o[p[p.length - 1]] = val; }
  function getPath(path) { var p = path.split('.'), o = S; for (var i = 0; i < p.length; i++) o = o[p[i]]; return o; }
  function wire(host) {
    host.querySelectorAll('input[data-k],textarea[data-k]').forEach(function (inp) {
      inp.oninput = function () {
        var k = inp.dataset.k;
        if (k === 'word' || k === 'date' || k === 'place' || k === 'headline') S.front[k] = inp.value;
        else if (k === 'letter') S.in1.letter = inp.value;
        else if (k === 'moments') S.in2.moments = inp.value;
        else if (k.indexOf('in1cap') === 0) S.in1.polas[+k.slice(6)].c = inp.value;
        refreshPreview();
      };
    });
    /* word inputs: grey suggestion vanishes on focus */
    host.querySelectorAll('input[data-word]').forEach(function (inp) {
      var i = +inp.dataset.word;
      inp.onfocus = function () { if (inp.value === inp.dataset.default) { inp.value = ''; inp.classList.remove('cb-snews__sugg'); S.in2.words[i] = ''; GRID = buildGrid(S.in2.words); refreshPreview(); } };
      inp.oninput = function () { inp.classList.remove('cb-snews__sugg'); S.in2.words[i] = inp.value.toUpperCase(); GRID = buildGrid(S.in2.words); refreshPreview(); };
    });
    host.querySelectorAll('[data-seg]').forEach(function (seg) {
      seg.querySelectorAll('button').forEach(function (b) { b.onclick = function () { setPath(seg.dataset.seg, b.dataset.v); seg.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); refreshPreview(); }; });
    });
    host.querySelectorAll('[data-up]').forEach(function (btn) {
      if (getPath(btn.dataset.up)) setUp(btn, true);
      btn.onclick = function () { pickPhoto(btn, function (url) { if (!url) return; setPath(btn.dataset.up, url); setUp(btn, true); refreshPreview(); }); };
    });
    host.querySelectorAll('[data-go]').forEach(function (b) { b.onclick = function () { S.tab = b.dataset.go; render(); }; });
    var sizes = host.querySelector('[data-sizes]');
    if (sizes) sizes.querySelectorAll('button').forEach(function (b) { b.onclick = function () { CFG.variantId = b.dataset.vid; sizes.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); var cta = host.querySelector('[data-addcart]'); if (cta) cta.disabled = false; }; });
    var add = host.querySelector('[data-addcart]');
    if (add) add.onclick = addToCart;
  }

  /* ---- add to cart --------------------------------------------------- */
  function buildProps() {
    return {
      'Edition for': S.in1.sibling,
      'Title': 'The ' + S.front.word + ' Times',
      'Headline': S.front.headline,
      'Date': S.front.date, 'Place': S.front.place,
      '_front_photo': S.front.photo || '',
      '_back_photos': S.back.photos.join(' | '),
      '_in1_hero': S.in1.hero || '',
      '_in1_letter': S.in1.letter,
      '_in1_photos': S.in1.polas.map(function (x) { return x.p || ''; }).join(' | '),
      '_in1_captions': S.in1.polas.map(function (x) { return x.c || ''; }).join(' | '),
      '_in2_moments': S.in2.moments,
      '_in2_photos': S.in2.polas.map(function (x) { return x || ''; }).join(' | '),
      '_in2_words': GRID.clean.join(', '),
      '_design_json': JSON.stringify({ front: S.front, back: S.back, in1: S.in1, in2: S.in2, grid: GRID.grid.map(function (r) { return r.join(''); }) })
    };
  }
  function addToCart(e) {
    var btn = e.currentTarget; btn.disabled = true; btn.innerHTML = I.cart + 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(CFG.variantId), quantity: 1, properties: buildProps() }] }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); window.location.href = CFG.cartRedirect; })
      .catch(function () { btn.disabled = false; btn.innerHTML = I.cart + 'Add to cart'; alert('Could not add to cart — please retry.'); });
  }

  render();
})();